import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../EditorLoadableWrapper';
import { EditorProps } from '../../types';
import retry from '../../../utils/chunkRetry';

const LoadableEditor = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "editor_v3", webpackPrefetch: true */
        './AttachmentCaption'
      )
  )
);

const AttachmentCaptionEditorLoadable: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId'>
> = props => {
  return (
    <EditorLoadableWrapper>
      <LoadableEditor {...props} />
    </EditorLoadableWrapper>
  );
};
AttachmentCaptionEditorLoadable.displayName = 'AttachmentCaptionEditor';

export default AttachmentCaptionEditorLoadable;
